import tracerConfig from '@/config/tracer'

function tracer() {
  if (!tracerConfig.useTracer) return
  mcTracer.init(tracerConfig.projectConfig, tracerConfig.baseParam)
}

export default tracer